<template>
  <div class="cwddgj-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="改价查收">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="getData" clearable>
                <el-option label="已查收" :value="1" />
                <el-option label="未查收" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="getData"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24">
                <el-table
                  v-loading="tableLoading"
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120">
                    <template slot-scope="scope">
                      <span>{{scope.row.orderNum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="100">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produNum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="140"
                    prop="allName">
                  </el-table-column>
                  <el-table-column
                    label="地址"
                    min-width="180"
                    show-overflow-tooltip
                    prop="address">
                  </el-table-column>
                  <el-table-column
                    label="原报价"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                      <span style="color:#F56C6C;font-weight: 500">{{scope.row.oldamount}} </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="现报价"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                      <span style="color:#67C23A;font-weight: 500">{{scope.row.newamount}} </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="改价人"
                    align="center"
                    width="95"
                    prop="username">
                  </el-table-column>
                  <el-table-column
                    label="改价时间"
                    width="160"
                    prop="time">
                  </el-table-column>
                  <el-table-column
                    label="查收状态"
                    align="center"
                    fixed="right"
                    width="80">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isCheck === 0" size="mini" type="danger">未查收</el-tag>
                      <el-tag v-if="scope.row.isCheck === 1" size="mini" type="success">已查收</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    fixed="right"
                    width="120"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button :disabled="scope.row.isCheck===1" size="mini" icon="el-icon-check" @click.stop="view(scope.row)">查收</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  style="margin-top: 20px;"
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getCwOrderChangePriceList, checkChangePrice } from '@/api/erp'

export default {
  name: 'cwddgj',
  data() {
    return {
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        type: ''
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        isCheck: this.searchForm.type
      }
      this.tableLoading = true
      getCwOrderChangePriceList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    view(row) {
      this.$confirm('您确定已查收此条记录吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        const data = {
          cpid: row.cpid,
          userid: this.user.dUserid
        }
        checkChangePrice(data).then(response => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.getData()
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>
